import type { FC } from 'react';
import { Navigate, Route } from 'react-router-dom';
import type { RemitReportingEntrypoint } from 'src/apis/remit-reporting/types';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PrimaryRemitReportsOverview } from 'src/pages/reporting/remit-reports/overview';
import { TsoReportsOverview } from 'src/pages/reporting/remit-reports/tso-reports';

const Page: FC<{ entrypoint: RemitReportingEntrypoint }> = ({ entrypoint }) => {
  const isFindPrimaryReports = !!entrypoint._links?.['find-primary-reports'];
  const isFindTsoSuppliedReports =
    !!entrypoint._links?.['find-tso-supplied-reports'];
  return (
    <RootRoutes>
      {isFindPrimaryReports && (
        <Route
          path="/reporting/remit-reports/*"
          element={<Navigate replace to="/reporting/remit-reports/reports" />}
        />
      )}

      {!isFindPrimaryReports && isFindTsoSuppliedReports && (
        <Route
          path="/reporting/remit-reports/*"
          element={
            <Navigate replace to="/reporting/remit-reports/tso-reports" />
          }
        />
      )}

      <Route
        path="/reporting/remit-reports/reports"
        element={
          entrypoint._links?.['find-primary-reports'] ? (
            <PrimaryRemitReportsOverview entrypoint={entrypoint} />
          ) : (
            <ThrowNotFound />
          )
        }
      />
      <Route
        path="/reporting/remit-reports/tso-reports"
        element={
          entrypoint._links?.['find-tso-supplied-reports'] ? (
            <TsoReportsOverview entrypoint={entrypoint} />
          ) : (
            <ThrowNotFound />
          )
        }
      />
      <Route
        path="/reporting/remit-reports/reports/*"
        element={<ThrowNotFound />}
      />
      <Route
        path="/reporting/remit-reports/tso-reports/*"
        element={<ThrowNotFound />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};

export default Page;
